import React from 'react'
import styled from 'styled-components'

const GhostButtonView = styled.div`
  font-family: 'Sica', sans-serif;
  display: inline-block;
  position: relative;
  padding: .8rem 4rem;
  border-radius: 2rem;
  border: 1px solid #ffffff;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 100;
  cursor: pointer;
  background-color: transparent;
  width: ${props => props.width || '200px'};
  height: ${props => props.height || '39px'};
  cursor: pointer;
  opacity: ${({ isTransparent }) => isTransparent ? 0 : 1};
  transition: filter .1s linear;

  &:visited {
    color: #ffffff;
  }

  button:focus &,
  &:hover * {
    color: #041E42;
  }

  button:focus &,
  &:hover {

    .bg {
      height: 100%;
      width: 101%;
    }
  }

  &:active {
    filter: brightness(80%);
  }
`

const TextHolder = styled.p`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

const GhostButtonBG = styled.div`
  display: block;
  position: absolute;
  bottom: 0;
  height: 0;
  left: 50%;
  width: calc(100% - 2.4rem);
  border-radius: 2rem;
  transform: translate(-50%);
  background: #ffffff;
  transition: all .23s ease-in-out;
`

const GhostButton = ({ children, ...rest }) => (
  <GhostButtonView {...rest}>
    <GhostButtonBG className='bg' />
    <TextHolder>
      {children}
    </TextHolder>
  </GhostButtonView>
)

export default GhostButton